<template>
  <div class="p-4">
    <div class="columns is-mobile is-variable is-1">
      <div class="column is-narrow-desktop">
        <b-field>
          <b-input
            placeholder="Ketik untuk mencari.."
            type="search"
            icon="magnify"
            @input="onSearch"
            expanded
          ></b-input>
        </b-field>
      </div>
      <div class="column is-narrow-touch">
        <b-tooltip label="Refresh" type="is-dark">
          <button
            type="button"
            class="button"
            @click="load"
            :disabled="isLoadingTable"
          >
            <b-icon icon="refresh"></b-icon>
          </button>
        </b-tooltip>
      </div>
      <div class="column is-narrow-touch has-text-right">
        <b-button
          tag="router-link"
          class="is-hidden-label-mobile"
          :to="{ name: 'unit-create' }"
          type="is-primary"
          icon-left="plus-thick"
        >
          Tambah
        </b-button>
      </div>
    </div>

    <b-table
      :data="data"
      :total="total"
      :loading="isLoadingTable"
      @page-change="onPageChange"
      @filters-change="onFilterChange"
      @sort="onSort"
      per-page="10"
      paginated
      :debounce-search="1000"
      backend-pagination
      backend-sorting
      backend-filtering
      sort-icon="arrow-down"
      sort-icon-size="is-small"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :row-class="row => (deletedIds.includes(row.id) ? 'deleted-row' : '')"
      :default-sort="[sortField, sortOrder]"
    >
      <b-table-column
        field="id"
        label="ID"
        :searchable="searchable"
        sortable
        numeric
        v-slot="props"
      >
        {{ props.row.id }}
      </b-table-column>

      <b-table-column
        field="name"
        label="Nama"
        :searchable="searchable"
        sortable
        v-slot="props"
      >
        {{ props.row.name | lowercase | capitalize }}
      </b-table-column>

      <b-table-column v-slot="props">
        <div class="c-action-column" v-if="!deletedIds.includes(props.row.id)">
          <b-tooltip label="Ubah" type="is-dark">
            <router-link
              :to="{ name: 'unit-edit', params: { id: props.row.id } }"
            >
              <button type="button" class="button is-small is-white">
                <b-icon icon="pencil-outline"></b-icon>
              </button>
            </router-link>
          </b-tooltip>

          <b-tooltip label="Hapus" type="is-dark">
            <button
              type="button"
              class="button is-small is-white"
              @click="deleteDialog(props.row)"
            >
              <b-icon icon="delete-outline"></b-icon>
            </button>
          </b-tooltip>
        </div>
        <span
          class="has-text-danger has-text-weight-medium"
          v-if="deletedIds.includes(props.row.id)"
        >
          Dihapus
        </span>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import CDialogPopup from "@/components/CDialogPopup";

export default {
  name: "Unit",
  data() {
    return {
      data: [],
      total: 0,
      sortField: "id",
      sortOrder: "desc",
      deletedIds: [],
      searchable: false,
      currentPage: 1,
      isLoadingTable: false,
      filter: {},
      searchDebounce: null
    };
  },
  methods: {
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.load();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.load();
    },
    onFilterChange(filter) {
      this.filter = filter;
      this.load();
    },
    onSearch(value) {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }

      this.filter = { search: value };
      this.searchDebounce = setTimeout(this.load, 500);
    },
    load() {
      this.isLoadingTable = true;

      this.$http({
        url: `employee_units`,
        method: "GET",
        params: {
          ...this.filter,
          page: this.currentPage,
          sort: this.sortField,
          direction: this.sortOrder
        }
      })
        .then(res => {
          this.isLoadingTable = false;

          this.data = res.data.data;
          this.total = res.data.meta.total;
        })
        .catch(() => {
          this.isLoadingTable = false;

          this.$buefy.snackbar.open({
            message: "Gagal memuat daftar Unit Kerja",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba lagi",
            onAction: () => {
              this.load();
            }
          });
        });
    },
    deleteDialog(row) {
      let name = this.$options.filters.capitalize(row.name.toLowerCase());
      name = this.$options.filters.truncate(name, 20);

      this.$buefy.modal.open({
        parent: this,
        animation: "zoom-out",
        events: {
          onPositiveAction: () => this.delete(row)
        },
        props: {
          title: "Hapus Unit Kerja",
          subtitle: `Hapus "${name}" dari daftar Unit Kerja? Tindakan ini tidak dapat diurungkan.`,
          positiveLabel: "Hapus",
          negativeLabel: "Batal",
          type: "is-danger"
        },
        component: CDialogPopup
      });
    },
    delete(row) {
      this.isLoadingTable = true;

      this.$http({
        url: `employee_units/${row.id}`,
        method: "DELETE"
      })
        .then(() => {
          this.isLoadingTable = false;
          this.deletedIds.push(row.id);

          this.$buefy.toast.open({
            message:
              'Satu Unit Kerja berhasil dihapus <i class="mdi mdi-check-bold has-text-success"></i>'
          });

          setTimeout(() => {
            const index = this.data.indexOf(row);
            this.data.splice(index, 1);
          }, 3200);
        })
        .catch(() => {
          this.isLoadingTable = false;

          this.$buefy.snackbar.open({
            message: "Gagal menghapus Unit Kerja ini",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => this.delete(row)
          });
        });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped lang="scss">
::v-deep .b-table tr.deleted-row {
  background-color: $danger-light !important;
  animation: example 0.2s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
}

@keyframes example {
  from {
    opacity: 0.7;
  }
  to {
    opacity: 0;
  }
}
</style>
